import { c as _c } from "react/compiler-runtime";
import { Button, Input } from '@common/components';
import { useToast } from '@common/hooks';
import SvgChevronleft from '@common/icon/SvgChevronleft';
import SvgDelete from '@common/icon/SvgDelete';
import SvgExpandWindow from '@common/icon/SvgExpandWindow';
import SvgHome from '@common/icon/SvgHome';
import SvgKebab from '@common/icon/SvgKebab';
import SvgLogo from '@common/icon/SvgLogo';
import SvgMagnifyingGlass from '@common/icon/SvgMagnifyingGlass';
import SvgMyFill from '@common/icon/SvgMyFill';
import SvgNotification from '@common/icon/SvgNotification';
import SvgSetting from '@common/icon/SvgSetting';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { type ReactNode, useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { CustomLink } from '@/app/_components/CustomLink';
import { openShareDrawer } from '@/app/_components/GlobalModal/_components/ShareDrawer';
import { shouldShowMobileTrendKeyword } from '@/app/_components/TrendKeyword/constants';
import { TrendKeywordBar } from '@/app/_components/TrendKeyword/TrendKeywordBar';
import SmallLogo from '@/assets/svgs/small_logo.svg';
import { DONATION_ROUTES, MODULE_ROUTES, ROUTES, SUB_DOMAIN } from '@/constants';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { usePartnerChromeClassName } from '@/hooks/usePartnerChromeClassName';
import { KakaobankExitConfirmModal } from '@/modules/kakaobank/_components/KakaobankExitConfirmModal';
import { requestKakaobankClose } from '@/modules/kakaobank/_utils/appBridge';
import { KAKAOBANK_NAV_SUBTITLE, resolveKakaobankNavTitle } from '@/modules/kakaobank/_utils/navTitle';
import { TossExitConfirmModal, useTossWebView } from '@/modules/toss';
import type { FlutterInAppWebViewWindow } from '@/modules/wello-app';
import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
import { useKakaobankExitStore } from '@/stores/KakaobankExitStore';
import { findRoute } from '@/utils';
import { gtmDatasets } from '@/utils/analytics/gtm';
import { Image } from '../Image/Image';
const TOSS_LOGO_URL = 'https://cdn.welfarehello.com/static/toss-logo.png';
type NavigationRouter = Pick<ReturnType<typeof useCustomRouter>, 'push' | 'replace' | 'back'>;
export type PageNavigationContentProps = PageNavigationProps & {
  isToss: boolean;
  isKakaobank: boolean;
  isLogin?: boolean;
  pathname: string;
  router: NavigationRouter;
  openConfirmModal: VoidFunction;
  closeConfirmModal: VoidFunction;
  confirmAndClose: VoidFunction;
  isModalOpened: boolean;
};
const PageNavigationContent = t0 => {
  const $ = _c(135);
  const {
    logo,
    logoHref,
    title,
    titleLeft,
    children,
    backButton: t1,
    backButtonType: t2,
    searchButton,
    bellButton,
    notification,
    shareButton,
    settingsButton,
    kebabButton,
    onClickBack,
    onClickKebab,
    hideHomeButton,
    className,
    style,
    textColor,
    isNotUsedHomeButton,
    donationHomeButton,
    searchForm,
    searchFormDefaultValue,
    searchFormClassName,
    onSearchFormMount,
    onSearchFormClick,
    onSearchFormSubmit,
    isToss,
    isKakaobank,
    isLogin,
    pathname,
    router,
    openConfirmModal,
    closeConfirmModal,
    confirmAndClose,
    isModalOpened
  } = t0;
  const backButton = t1 === undefined ? true : t1;
  const backButtonType = t2 === undefined ? "back" : t2;
  const partnerChromeClassName = usePartnerChromeClassName();
  const hasBottomNav = findRoute(pathname)?.hasBottomNav;
  const [isKakaobankExitOpened, openKakaobankExit, closeKakaobankExit] = useKakaobankExitStore(useShallow(_temp));
  const {
    toast
  } = useToast();
  let t3;
  if ($[0] !== closeKakaobankExit || $[1] !== toast) {
    t3 = () => {
      try {
        requestKakaobankClose();
      } catch {
        closeKakaobankExit();
        toast({
          type: "fail",
          message: "\uC9C0\uAE08\uC740 \uC885\uB8CC\uD560 \uC218 \uC5C6\uC5B4\uC694. \uCE74\uCE74\uC624\uBC45\uD06C \uC571\uC744 \uCD5C\uC2E0 \uBC84\uC804\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8\uD574\uC8FC\uC138\uC694."
        });
      }
    };
    $[0] = closeKakaobankExit;
    $[1] = toast;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleKakaobankClose = t3;
  const DEFAULT_LOGO_HREF = isToss ? DONATION_ROUTES.HOME.pathname : ROUTES.HOME.pathname;
  let t4;
  if ($[3] !== isKakaobank || $[4] !== onClickBack || $[5] !== router) {
    t4 = onClickBack ? typeof onClickBack === "string" ? () => router.replace(onClickBack) : onClickBack : () => router.back(isKakaobank ? DONATION_ROUTES.HOME.pathname : undefined);
    $[3] = isKakaobank;
    $[4] = onClickBack;
    $[5] = router;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleBack = t4;
  const backFallbackHref = typeof onClickBack === "string" ? onClickBack : pathname.startsWith(DONATION_ROUTES.HOME.pathname) ? DONATION_ROUTES.HOME.pathname : ROUTES.HOME.pathname;
  if (isKakaobank) {
    let t5;
    if ($[7] !== pathname) {
      t5 = DONATION_ROUTES.HOME.isMatchPathname(pathname);
      $[7] = pathname;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    const isDonationHome = t5;
    let t6;
    if ($[9] !== backButton || $[10] !== pathname) {
      t6 = backButton && !DONATION_ROUTES.CALLBACK.isMatchPathname(pathname);
      $[9] = backButton;
      $[10] = pathname;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    const hasBackButton = t6;
    let t7;
    if ($[12] !== pathname || $[13] !== title) {
      t7 = resolveKakaobankNavTitle(pathname) ?? title;
      $[12] = pathname;
      $[13] = title;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    const navTitle = t7;
    let t8;
    if ($[15] !== isLogin) {
      t8 = isLogin === false ? ROUTES.LOGIN.withSearchParams({
        searchParams: {
          redirect: DONATION_ROUTES.MY.pathname
        }
      }) : DONATION_ROUTES.MY.pathname;
      $[15] = isLogin;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    const myHref = t8;
    const kakaobankSearchHref = typeof searchButton === "string" ? searchButton : DONATION_ROUTES.SEARCH.pathname;
    let t9;
    if ($[17] !== handleBack || $[18] !== hasBackButton || $[19] !== isDonationHome || $[20] !== openKakaobankExit) {
      t9 = isDonationHome ? {
        label: "\uCE74\uCE74\uC624\uBC45\uD06C\uB85C \uB3CC\uC544\uAC00\uAE30",
        icon: <SvgDelete className="size-24" />,
        onClick: openKakaobankExit
      } : hasBackButton ? {
        label: "\uB4A4\uB85C \uAC00\uAE30",
        icon: <SvgChevronleft className="size-24" />,
        onClick: handleBack
      } : null;
      $[17] = handleBack;
      $[18] = hasBackButton;
      $[19] = isDonationHome;
      $[20] = openKakaobankExit;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    const leftAction = t9;
    const t10 = isDonationHome ? "pr-8" : "pr-16";
    let t11;
    if ($[22] !== className || $[23] !== partnerChromeClassName || $[24] !== t10) {
      t11 = cn("relative flex min-h-48 w-full items-center justify-between pl-4", t10, "box-border select-none bg-Gray-white text-center", partnerChromeClassName, className);
      $[22] = className;
      $[23] = partnerChromeClassName;
      $[24] = t10;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    let t12;
    if ($[26] !== leftAction) {
      t12 = leftAction ? <Button aria-label={leftAction.label} className="relative size-26 p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H26" theme="primary-text" onClick={leftAction.onClick}>{leftAction.icon}</Button> : null;
      $[26] = leftAction;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    let t13;
    if ($[28] !== t12) {
      t13 = <div className="grid size-44 shrink-0 place-items-center">{t12}</div>;
      $[28] = t12;
      $[29] = t13;
    } else {
      t13 = $[29];
    }
    let t14;
    if ($[30] !== navTitle) {
      t14 = navTitle ? <h3 className="w-full truncate font-700 text-Gray-900 typo-body3">{navTitle}</h3> : null;
      $[30] = navTitle;
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    let t15;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <p className="font-400 text-Gray-700 typo-caption1">{KAKAOBANK_NAV_SUBTITLE}</p>;
      $[32] = t15;
    } else {
      t15 = $[32];
    }
    let t16;
    if ($[33] !== t14) {
      t16 = <div className="absolute inset-x-0 mx-auto flex w-185 flex-col items-center gap-2 px-8">{t14}{t15}</div>;
      $[33] = t14;
      $[34] = t16;
    } else {
      t16 = $[34];
    }
    let t17;
    if ($[35] !== isDonationHome || $[36] !== kakaobankSearchHref || $[37] !== myHref || $[38] !== openKakaobankExit || $[39] !== searchButton) {
      t17 = <div className="z-[1] flex shrink-0 items-center">{isDonationHome ? <>{searchButton ? <div className="grid size-44 place-items-center"><Button aria-label={"\uAC80\uC0C9\uC73C\uB85C \uC774\uB3D9"} asChild={true} className="relative size-26 p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H26" theme="primary-text"><CustomLink href={kakaobankSearchHref}><SvgMagnifyingGlass className="size-24" /></CustomLink></Button></div> : null}<div className="grid size-44 place-items-center"><Button aria-label="MY" asChild={true} className="relative size-26 p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H26" theme="primary-text"><CustomLink href={myHref}><SvgMyFill className="size-24" /></CustomLink></Button></div></> : <Button aria-label={"\uCE74\uCE74\uC624\uBC45\uD06C\uB85C \uB3CC\uC544\uAC00\uAE30"} className="relative h-26 whitespace-nowrap p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H40" theme="primary-text" onClick={openKakaobankExit}>닫기</Button>}</div>;
      $[35] = isDonationHome;
      $[36] = kakaobankSearchHref;
      $[37] = myHref;
      $[38] = openKakaobankExit;
      $[39] = searchButton;
      $[40] = t17;
    } else {
      t17 = $[40];
    }
    let t18;
    if ($[41] !== closeKakaobankExit || $[42] !== handleKakaobankClose || $[43] !== isKakaobankExitOpened) {
      t18 = <KakaobankExitConfirmModal opened={isKakaobankExitOpened} onClose={closeKakaobankExit} onConfirm={handleKakaobankClose} />;
      $[41] = closeKakaobankExit;
      $[42] = handleKakaobankClose;
      $[43] = isKakaobankExitOpened;
      $[44] = t18;
    } else {
      t18 = $[44];
    }
    let t19;
    if ($[45] !== style || $[46] !== t11 || $[47] !== t13 || $[48] !== t16 || $[49] !== t17 || $[50] !== t18) {
      t19 = <nav aria-label={"\uD398\uC774\uC9C0 \uB0B4\uBE44\uAC8C\uC774\uC158"} className={t11} style={style}>{t13}{t16}{t17}{t18}</nav>;
      $[45] = style;
      $[46] = t11;
      $[47] = t13;
      $[48] = t16;
      $[49] = t17;
      $[50] = t18;
      $[51] = t19;
    } else {
      t19 = $[51];
    }
    return t19;
  }
  let t5;
  if ($[52] !== className || $[53] !== partnerChromeClassName) {
    t5 = cn("relative flex min-h-48 w-full items-center", "box-border select-none bg-Gray-white text-center", partnerChromeClassName, className);
    $[52] = className;
    $[53] = partnerChromeClassName;
    $[54] = t5;
  } else {
    t5 = $[54];
  }
  let t6;
  if ($[55] !== textColor || $[56] !== titleLeft) {
    t6 = titleLeft ? <h3 className={cn("absolute left-20 font-700 flex-center typo-h6", textColor)}>{titleLeft}</h3> : null;
    $[55] = textColor;
    $[56] = titleLeft;
    $[57] = t6;
  } else {
    t6 = $[57];
  }
  let t7;
  if ($[58] !== textColor || $[59] !== title) {
    t7 = title ? <h3 className={cn("absolute flex size-full items-center justify-center", "break-all text-center font-600 text-Gray-900 typo-body3", textColor)}>{title}</h3> : null;
    $[58] = textColor;
    $[59] = title;
    $[60] = t7;
  } else {
    t7 = $[60];
  }
  let t8;
  if ($[61] !== DEFAULT_LOGO_HREF || $[62] !== isToss || $[63] !== logo || $[64] !== logoHref) {
    t8 = logo ? <div className="flex items-center gap-12"><div className={cn("flex items-center gap-12", {
        "gap-2": isToss
      })}>{isToss ? <><Image src={TOSS_LOGO_URL} alt="toss" width={31} height={31} /><SvgDelete className="size-20 text-Gray-400" /></> : null}<CustomLink aria-label={"\uC6F0\uB85C"} href={logoHref ?? DEFAULT_LOGO_HREF} {...gtmDatasets.clickGnb({
          menu_name: "\uB85C\uACE0"
        })}>{logo === "symbol" ? <SmallLogo className="size-40" /> : <SvgLogo className="h-29 w-86" />}</CustomLink></div></div> : null;
    $[61] = DEFAULT_LOGO_HREF;
    $[62] = isToss;
    $[63] = logo;
    $[64] = logoHref;
    $[65] = t8;
  } else {
    t8 = $[65];
  }
  let t9;
  if ($[66] !== backButton || $[67] !== backButtonType || $[68] !== backFallbackHref || $[69] !== handleBack || $[70] !== textColor) {
    t9 = backButton ? <Button asChild={true} className="relative size-26 p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H26" theme="primary-text"><a aria-label={"\uB4A4\uB85C \uAC00\uAE30"} href={backFallbackHref} onClick={event => {
        event.preventDefault();
        handleBack();
      }}>{backButtonType === "back" ? <SvgChevronleft className={cn("size-24", textColor)} /> : <SvgDelete className={cn("size-24", textColor)} />}</a></Button> : null;
    $[66] = backButton;
    $[67] = backButtonType;
    $[68] = backFallbackHref;
    $[69] = handleBack;
    $[70] = textColor;
    $[71] = t9;
  } else {
    t9 = $[71];
  }
  let t10;
  if ($[72] !== hasBottomNav || $[73] !== hideHomeButton || $[74] !== isNotUsedHomeButton || $[75] !== router || $[76] !== textColor) {
    t10 = !hasBottomNav && !isNotUsedHomeButton ? <Button aria-label={"\uD648\uC73C\uB85C \uAC00\uAE30"} className={cn("relative size-26 p-0", hideHomeButton && "hidden")} dimensions="H26" theme="primary-text" onClick={() => router.push(ROUTES.HOME.pathname)}><SvgHome className={cn("size-24", textColor)} /></Button> : null;
    $[72] = hasBottomNav;
    $[73] = hideHomeButton;
    $[74] = isNotUsedHomeButton;
    $[75] = router;
    $[76] = textColor;
    $[77] = t10;
  } else {
    t10 = $[77];
  }
  let t11;
  if ($[78] !== donationHomeButton || $[79] !== router || $[80] !== textColor) {
    t11 = donationHomeButton ? <Button aria-label={"\uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80 \uD648\uC73C\uB85C \uAC00\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={() => router.push(DONATION_ROUTES.HOME.pathname)}><SvgHome className={cn("size-24", textColor)} /></Button> : null;
    $[78] = donationHomeButton;
    $[79] = router;
    $[80] = textColor;
    $[81] = t11;
  } else {
    t11 = $[81];
  }
  let t12;
  if ($[82] !== onSearchFormClick || $[83] !== onSearchFormMount || $[84] !== onSearchFormSubmit || $[85] !== searchForm || $[86] !== searchFormClassName || $[87] !== searchFormDefaultValue) {
    t12 = searchForm ? <Input ref={el => {
      if (!el) {
        return;
      }
      onSearchFormMount?.(el);
    }} key={searchFormDefaultValue} type="search" placeholder={"\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694"} dimensions="H40" defaultValue={searchFormDefaultValue} className={cn("my-12 w-full select-text border-none bg-Gray-200 text-Gray-900 placeholder:text-Gray-550 focus:border-none", searchFormClassName)} onClick={() => onSearchFormClick?.()} onKeyDown={e => {
      if (e.key === "Enter") {
        onSearchFormSubmit?.(e.currentTarget.value);
      }
    }} onClear={() => onSearchFormSubmit?.("")} /> : null;
    $[82] = onSearchFormClick;
    $[83] = onSearchFormMount;
    $[84] = onSearchFormSubmit;
    $[85] = searchForm;
    $[86] = searchFormClassName;
    $[87] = searchFormDefaultValue;
    $[88] = t12;
  } else {
    t12 = $[88];
  }
  let t13;
  if ($[89] !== t10 || $[90] !== t11 || $[91] !== t12 || $[92] !== t8 || $[93] !== t9) {
    t13 = <div className="z-[1] flex min-w-0 grow items-center gap-20 pl-20">{t8}{t9}{t10}{t11}{t12}</div>;
    $[89] = t10;
    $[90] = t11;
    $[91] = t12;
    $[92] = t8;
    $[93] = t9;
    $[94] = t13;
  } else {
    t13 = $[94];
  }
  let t14;
  if ($[95] !== searchButton || $[96] !== textColor) {
    t14 = searchButton ? <Button aria-label={"\uAC80\uC0C9\uC73C\uB85C \uC774\uB3D9"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" asChild={true} {...gtmDatasets.clickGnb({
      menu_name: "\uAC80\uC0C9"
    })}><CustomLink href={typeof searchButton === "boolean" ? ROUTES.SEARCH.pathname : searchButton}><SvgMagnifyingGlass className={cn("size-24", textColor)} /></CustomLink></Button> : null;
    $[95] = searchButton;
    $[96] = textColor;
    $[97] = t14;
  } else {
    t14 = $[97];
  }
  let t15;
  if ($[98] !== bellButton || $[99] !== notification || $[100] !== router || $[101] !== textColor) {
    t15 = bellButton ? <Button aria-label={"\uC54C\uB9BC\uC73C\uB85C \uC774\uB3D9"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={() => {
      router.push(ROUTES.PUSH.pathname);
    }}><SvgNotification className={cn("size-24", textColor)} />{notification ? <span className="absolute right-14 top-12 box-content size-4 rounded-pill border-2 border-Gray-100 bg-R-500" /> : null}</Button> : null;
    $[98] = bellButton;
    $[99] = notification;
    $[100] = router;
    $[101] = textColor;
    $[102] = t15;
  } else {
    t15 = $[102];
  }
  let t16;
  if ($[103] !== shareButton || $[104] !== textColor) {
    t16 = shareButton ? <Button aria-label={"\uACF5\uC720\uD558\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={_temp2}><SvgExpandWindow className={cn("size-24", textColor)} /></Button> : null;
    $[103] = shareButton;
    $[104] = textColor;
    $[105] = t16;
  } else {
    t16 = $[105];
  }
  let t17;
  if ($[106] !== router || $[107] !== settingsButton || $[108] !== textColor) {
    t17 = settingsButton ? <Button aria-label={"\uC124\uC815"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={() => router.push(ROUTES.MY_SETTINGS.pathname)}><SvgSetting className={cn("size-24", textColor)} /></Button> : null;
    $[106] = router;
    $[107] = settingsButton;
    $[108] = textColor;
    $[109] = t17;
  } else {
    t17 = $[109];
  }
  let t18;
  if ($[110] !== kebabButton || $[111] !== onClickKebab || $[112] !== textColor) {
    t18 = kebabButton ? typeof kebabButton === "boolean" ? <Button aria-label={"\uB354\uBCF4\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={onClickKebab}><SvgKebab className={cn("size-24", textColor)} /></Button> : kebabButton : null;
    $[110] = kebabButton;
    $[111] = onClickKebab;
    $[112] = textColor;
    $[113] = t18;
  } else {
    t18 = $[113];
  }
  let t19;
  if ($[114] !== closeConfirmModal || $[115] !== confirmAndClose || $[116] !== isModalOpened || $[117] !== isToss || $[118] !== openConfirmModal) {
    t19 = isToss ? <><Button aria-label={"\uD1A0\uC2A4\uB85C \uC774\uB3D9"} className="relative h-26 whitespace-nowrap p-0" dimensions="H40" theme="primary-text" onClick={openConfirmModal}>닫기</Button><TossExitConfirmModal opened={isModalOpened} onClose={closeConfirmModal} onConfirm={confirmAndClose} /></> : null;
    $[114] = closeConfirmModal;
    $[115] = confirmAndClose;
    $[116] = isModalOpened;
    $[117] = isToss;
    $[118] = openConfirmModal;
    $[119] = t19;
  } else {
    t19 = $[119];
  }
  let t20;
  if ($[120] !== children || $[121] !== t14 || $[122] !== t15 || $[123] !== t16 || $[124] !== t17 || $[125] !== t18 || $[126] !== t19) {
    t20 = <div className="z-[1] ml-auto flex shrink-0 items-center justify-end gap-20 px-20">{t14}{t15}{children}{t16}{t17}{t18}{t19}</div>;
    $[120] = children;
    $[121] = t14;
    $[122] = t15;
    $[123] = t16;
    $[124] = t17;
    $[125] = t18;
    $[126] = t19;
    $[127] = t20;
  } else {
    t20 = $[127];
  }
  let t21;
  if ($[128] !== style || $[129] !== t13 || $[130] !== t20 || $[131] !== t5 || $[132] !== t6 || $[133] !== t7) {
    t21 = <nav aria-label={"\uD398\uC774\uC9C0 \uB0B4\uBE44\uAC8C\uC774\uC158"} className={t5} style={style}>{t6}{t7}{t13}{t20}</nav>;
    $[128] = style;
    $[129] = t13;
    $[130] = t20;
    $[131] = t5;
    $[132] = t6;
    $[133] = t7;
    $[134] = t21;
  } else {
    t21 = $[134];
  }
  return t21;
};
export interface PageNavigationProps {
  className?: string;
  title?: string | ReactNode;
  titleLeft?: string | ReactNode;
  children?: ReactNode;
  logo?: 'full' | 'symbol';
  logoHref?: string;
  searchButton?: boolean | string;
  bellButton?: boolean;
  shareButton?: boolean;
  notification?: boolean;
  settingsButton?: boolean;
  backButton?: boolean;
  backButtonType?: 'exit' | 'back';
  /** backButton 유무와 관계없이 뒤로가기 활성화 */
  enableHistoryBack?: boolean;
  kebabButton?: boolean | ReactNode;
  onClickKebab?: VoidFunction;
  hideHomeButton?: boolean;
  onClickBack?: VoidFunction | string;
  style?: React.CSSProperties;
  textColor?: string;
  isNotUsedHomeButton?: boolean;
  donationHomeButton?: boolean;
  //* 검색 폼 관련
  searchForm?: boolean;
  searchFormDefaultValue?: string;
  searchFormClassName?: string;
  onSearchFormMount?: (ref: HTMLInputElement) => void;
  onSearchFormClick?: () => void;
  onSearchFormSubmit?: (value: string) => void;
}
export const PageNavigation = props => {
  const $ = _c(70);
  const {
    logo,
    logoHref,
    title,
    titleLeft,
    children,
    backButton: t0,
    backButtonType: t1,
    enableHistoryBack,
    searchButton,
    bellButton,
    notification,
    shareButton,
    settingsButton,
    kebabButton,
    onClickBack,
    onClickKebab,
    hideHomeButton,
    className,
    style,
    textColor,
    isNotUsedHomeButton,
    donationHomeButton,
    searchForm,
    searchFormDefaultValue,
    searchFormClassName,
    onSearchFormMount,
    onSearchFormClick,
    onSearchFormSubmit
  } = props;
  const backButton = t0 === undefined ? true : t0;
  const backButtonType = t1 === undefined ? "back" : t1;
  const router = useCustomRouter();
  const {
    openConfirmModal,
    closeConfirmModal,
    confirmAndClose,
    isModalOpened
  } = useTossWebView();
  const [isKbWebview, setAppModal, isToss, isWelloApp] = useDeviceInfoStore(useShallow(_temp3));
  const isKakaobank = useCheckKakaobank();
  const isLogin = useAuthStore(_temp4);
  let t2;
  if ($[0] !== backButton || $[1] !== enableHistoryBack || $[2] !== router || $[3] !== setAppModal) {
    t2 = () => {
      const _window = window as FlutterInAppWebViewWindow;
      if (_window.router) {
        _window.router.back = backButton || enableHistoryBack ? () => router.back() : () => {
          setAppModal({
            isOpened: true,
            type: "exit"
          });
        };
        return () => {
          _window.router.back = () => router.back();
        };
      }
    };
    $[0] = backButton;
    $[1] = enableHistoryBack;
    $[2] = router;
    $[3] = setAppModal;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== backButton || $[6] !== enableHistoryBack || $[7] !== isWelloApp || $[8] !== router || $[9] !== setAppModal) {
    t3 = [backButton, enableHistoryBack, isWelloApp, router, setAppModal];
    $[5] = backButton;
    $[6] = enableHistoryBack;
    $[7] = isWelloApp;
    $[8] = router;
    $[9] = setAppModal;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
  const pathname = usePathname() ?? "";
  const shouldHideNavigation = isKbWebview && pathname !== MODULE_ROUTES.KB_HOME.pathname;
  let t4;
  if ($[11] !== backButton || $[12] !== backButtonType || $[13] !== bellButton || $[14] !== children || $[15] !== className || $[16] !== closeConfirmModal || $[17] !== confirmAndClose || $[18] !== donationHomeButton || $[19] !== enableHistoryBack || $[20] !== hideHomeButton || $[21] !== isKakaobank || $[22] !== isLogin || $[23] !== isModalOpened || $[24] !== isNotUsedHomeButton || $[25] !== isToss || $[26] !== kebabButton || $[27] !== logo || $[28] !== logoHref || $[29] !== notification || $[30] !== onClickBack || $[31] !== onClickKebab || $[32] !== onSearchFormClick || $[33] !== onSearchFormMount || $[34] !== onSearchFormSubmit || $[35] !== openConfirmModal || $[36] !== pathname || $[37] !== router || $[38] !== searchButton || $[39] !== searchForm || $[40] !== searchFormClassName || $[41] !== searchFormDefaultValue || $[42] !== settingsButton || $[43] !== shareButton || $[44] !== style || $[45] !== textColor || $[46] !== title || $[47] !== titleLeft) {
    t4 = {
      logo,
      logoHref,
      title,
      titleLeft,
      children,
      backButton,
      backButtonType,
      enableHistoryBack,
      searchButton,
      bellButton,
      notification,
      shareButton,
      settingsButton,
      kebabButton,
      onClickBack,
      onClickKebab,
      hideHomeButton,
      className,
      style,
      textColor,
      isNotUsedHomeButton,
      donationHomeButton,
      searchForm,
      searchFormDefaultValue,
      searchFormClassName,
      onSearchFormMount,
      onSearchFormClick,
      onSearchFormSubmit,
      isToss,
      isKakaobank,
      isLogin,
      pathname,
      router,
      openConfirmModal,
      closeConfirmModal,
      confirmAndClose,
      isModalOpened
    };
    $[11] = backButton;
    $[12] = backButtonType;
    $[13] = bellButton;
    $[14] = children;
    $[15] = className;
    $[16] = closeConfirmModal;
    $[17] = confirmAndClose;
    $[18] = donationHomeButton;
    $[19] = enableHistoryBack;
    $[20] = hideHomeButton;
    $[21] = isKakaobank;
    $[22] = isLogin;
    $[23] = isModalOpened;
    $[24] = isNotUsedHomeButton;
    $[25] = isToss;
    $[26] = kebabButton;
    $[27] = logo;
    $[28] = logoHref;
    $[29] = notification;
    $[30] = onClickBack;
    $[31] = onClickKebab;
    $[32] = onSearchFormClick;
    $[33] = onSearchFormMount;
    $[34] = onSearchFormSubmit;
    $[35] = openConfirmModal;
    $[36] = pathname;
    $[37] = router;
    $[38] = searchButton;
    $[39] = searchForm;
    $[40] = searchFormClassName;
    $[41] = searchFormDefaultValue;
    $[42] = settingsButton;
    $[43] = shareButton;
    $[44] = style;
    $[45] = textColor;
    $[46] = title;
    $[47] = titleLeft;
    $[48] = t4;
  } else {
    t4 = $[48];
  }
  const contentProps = t4;
  if (shouldHideNavigation) {
    return null;
  }
  const navHeightClass = searchForm && !isKakaobank ? "h-64" : "h-48";
  if (!shouldShowMobileTrendKeyword(pathname)) {
    let t5;
    if ($[49] !== navHeightClass) {
      t5 = cn("hidden mobile-tablet:block", navHeightClass);
      $[49] = navHeightClass;
      $[50] = t5;
    } else {
      t5 = $[50];
    }
    let t6;
    if ($[51] !== t5) {
      t6 = <div aria-hidden={true} className={t5} />;
      $[51] = t5;
      $[52] = t6;
    } else {
      t6 = $[52];
    }
    let t7;
    if ($[53] !== className || $[54] !== navHeightClass) {
      t7 = cn("fixed inset-x-0 top-0 z-20 hidden mobile-tablet:flex", navHeightClass, className);
      $[53] = className;
      $[54] = navHeightClass;
      $[55] = t7;
    } else {
      t7 = $[55];
    }
    let t8;
    if ($[56] !== contentProps || $[57] !== t7) {
      t8 = <PageNavigationContent {...contentProps} className={t7} />;
      $[56] = contentProps;
      $[57] = t7;
      $[58] = t8;
    } else {
      t8 = $[58];
    }
    let t9;
    if ($[59] !== t6 || $[60] !== t8) {
      t9 = <>{t6}{t8}</>;
      $[59] = t6;
      $[60] = t8;
      $[61] = t9;
    } else {
      t9 = $[61];
    }
    return t9;
  }
  let t5;
  if ($[62] !== className) {
    t5 = cn("flex", className);
    $[62] = className;
    $[63] = t5;
  } else {
    t5 = $[63];
  }
  let t6;
  if ($[64] !== contentProps || $[65] !== t5) {
    t6 = <PageNavigationContent {...contentProps} className={t5} />;
    $[64] = contentProps;
    $[65] = t5;
    $[66] = t6;
  } else {
    t6 = $[66];
  }
  let t7;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <TrendKeywordBar />;
    $[67] = t7;
  } else {
    t7 = $[67];
  }
  let t8;
  if ($[68] !== t6) {
    t8 = <div className="sticky top-0 z-20 hidden mobile-tablet:block">{t6}{t7}</div>;
    $[68] = t6;
    $[69] = t8;
  } else {
    t8 = $[69];
  }
  return t8;
};
function _temp(state) {
  return [state.isExitConfirmOpened, state.openExitConfirm, state.closeExitConfirm];
}
function _temp2() {
  openShareDrawer(location.href);
}
function _temp3(state) {
  return [state.webviewType === WEBVIEW_TYPE.KB_PAY, state.setAppModal, state.subDomain === SUB_DOMAIN.TOSS, state.webviewType === WEBVIEW_TYPE.WELLO_APP] as const;
}
function _temp4(state_0) {
  return state_0.isLogin;
}